module.exports = __webpack_public_path__ + "static/media/alcachofra.1c4c2ab2.png";